export const TargetDisable = ({ color = 'currentColor', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.0005"
      cy="12.7016"
      r="3.09615"
      stroke={color}
      strokeWidth="1.5"
    ></circle>
    <circle
      cx="12.0002"
      cy="12.7121"
      r="6.17308"
      stroke={color}
      strokeWidth="1.5"
    ></circle>
    <circle
      cx="12"
      cy="12.707"
      r="9.25"
      stroke={color}
      strokeWidth="1.5"
    ></circle>
    <line
      x1="0.353553"
      y1="0.353478"
      x2="24.3536"
      y2="24.3535"
      stroke={color}
    ></line>
  </svg>
);
